var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.886,
    height: 28.159,
    viewBox: "0 0 38.886 28.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_arrow_1709583_000000",
    d: "M59.379,41.738,48.655,29.67a2.011,2.011,0,1,0-3,2.682l7.751,8.716h-30.4a2.011,2.011,0,1,0,0,4.023h30.4l-7.751,8.716a2.061,2.061,0,0,0,.16,2.86,2.031,2.031,0,0,0,2.836-.178L59.382,44.42a2.034,2.034,0,0,0,0-2.682Z",
    transform: "translate(-20.999 -29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowImg);
export default __webpack_public_path__ + "static/media/arrow_img.7fbf04e894b1d10ba3c8ef3f92194d17.svg";
export { ForwardRef as ReactComponent };